export const permissionConst = {
  title: "Permissions",
  userPermission: "User-Role Permissions",
  userRoleAccess: "User-Role Permissions",
  successMsge: 'Updated successfully',
  failedMsge: 'Failed to update',
  success: "success",
  failed: "failed",
  displayedColumnsUserPer: [
    "userName",
    "userEmail",
    "edit",
    "deactivate",
  ],

  displayedKeyColumnsUserPer: [
    {
      name: 'Name/Role',
      value: 'userName'
    },
    {
      name: 'Email',
      value: 'userEmail'
    },
    {
      name: 'Add/Edit',
      value: 'edit'
    },
    {
      name: 'Activate/Deactivate',
      value: 'deactivate'
    }
  ],

  searchUser:"Search User",
  refreshUser:"Refresh User",
  auditLog:"User permission audit log"
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/utils/permission.ts